module.exports = __webpack_public_path__ + "img/badge.80cbf893.svg";